export default {
  onAppLaunch(vm) {
    this.vm = vm
    this.vm.$helper.sentSmsSuccessfullyNotify = (id = null) => {
      this.vm.$snotify.confirm(
        this.vm.i18n('send.sms.finished'),
        this.vm.i18n('send.success'),
        {
          type: 'success',
          timeout: 8000,
          showProgressBar: true,
          pauseOnHover: true,
          buttons: [{
            text: this.vm.i18n('sms.read.detail'),
            action: () => {
              const url = this.vm.$router.resolve({
                name: 'admin.sms-log-view',
                params: { id }
              }).href
              window.open(url)
            },
          }]
        }
      )
    }
  },

  widgets: {
    dashboard: {
      smsOverview: {
        name: 'widget.sms.overview',
        roles: ['ROLE_ADMIN', 'ROLE_SMS'],
        icon: 'fa fa-comment-alt',
        iconColor: 'orange lighten-2',
        grids: { xl: 6, lg: 6, md: 6, sm: 12, xs: 12 },
        component: () => import('modules/sms/widgets/dashboard/overview.vue'),
        defaultConfig(vm) {
          return {
            widgetName: 'smsOverview',
            config: {},
          }
        },
      },
    },
  },
}